import { EventDTO } from './EventDTO'

export class EventCollectionDTO {
  constructor(readonly events: EventDTO[], readonly totalEvents: number) {}
}
